var map = {
	"./pic-1.jpg": 798,
	"./pic-2.jpg": 799,
	"./pic-3.jpg": 800,
	"./pic-4.jpg": 801,
	"./pic-5.jpg": 802,
	"./pic-6.jpg": 803
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 797;